import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { loadOpenTasks } from "../actions";

const frontload = async (props) => await props.getTasks();
const mapStateToProps = null;
const mapDispatchToProps = (dispatch) => ({
  getTasks: (...args) => dispatch(loadOpenTasks(...args)),
});

function AllNewTasks({ children }) {
  return <div className={`new-tasks clearfix`}>{children}</div>;
}

AllNewTasks.propTypes = {
  getTasks: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(AllNewTasks),
);
